import Plyr from "plyr";
const videoEl = {
    playButtonIcon:
        '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
    playButton:
        '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
    muteButton:
        '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
    progressInput:
        '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
    volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
    fullscreen:
        '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>',
};
const videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
let videoPlayers = [];
export const Video = {
    init: function () {
        this.setupVideoPlayer();
    },
    setupVideoPlayer: function () {
        const productVideos = document.querySelectorAll("[data-html5-video] video, [data-youtube-video]");
        let setupVideoPlayers = Plyr.setup(productVideos, {
            controls: videoControls,
            ratio: this.aspect_ratio,
            fullscreen: {
                enabled: true,
                fallback: true,
                iosNative: true,
            },
            storage: {
                enabled: false,
            },
        });
        let videoLooping = $("[data-video-loop]").data("video-loop") || false;
        $.each(setupVideoPlayers, function (index, player) {
            player.loop = videoLooping;
            videoPlayers.push(player);
        });
        this.setupListeners();
    },
    setupListeners: function () {
        // Adds plyr video id to video wrapper
        $.each(videoPlayers, function (index, player) {
            const id = player.id;
            let $video;
            if (player.isHTML5) {
                $video = $(player.elements.wrapper).find("video");
                $video.attr("data-plyr-video-id", id);
            }
            // When a video is playing, pause any other instances
            player.on("play", function (event) {
                let instance = event.detail.plyr;
                $.each(videoPlayers, function (index, player) {
                    let playerID = player.id || player.media.dataset.plyrVideoId;
                    if (instance.id != playerID) {
                        player.pause();
                    }
                });
            });
        });
    },
    enableVideoOnHover: function ($thumbnail) {
        let $html5Video = $thumbnail.find("[data-html5-video]");
        let $youtubeVideo = $thumbnail.find("[data-youtube-video]");
        let videoID;
        if ($html5Video.length > 0) {
            videoID = $html5Video.find("[data-plyr-video-id]").data("plyr-video-id");
        } else if ($youtubeVideo.length > 0) {
            videoID = $youtubeVideo.find("iframe").attr("id");
        }
        if (videoID) {
            $.each(videoPlayers, function (index, player) {
                if (player.id == videoID || player.media.id == videoID) {
                    player.toggleControls(false);
                    player.muted = true;
                    player.play();
                }
            });
        }
    },
    disableVideoOnHover: function ($thumbnail) {
        let $html5Video = $thumbnail.find("[data-html5-video]");
        let $youtubeVideo = $thumbnail.find("[data-youtube-video]");
        let videoID;
        if ($html5Video.length > 0) {
            videoID = $html5Video.find("[data-plyr-video-id]").data("plyr-video-id");
        } else if ($youtubeVideo.length > 0) {
            videoID = $youtubeVideo.find("iframe").attr("id");
        }
        if (videoID) {
            $.each(videoPlayers, function (index, player) {
                if (player.id == videoID || player.media.id == videoID) {
                    if (player.playing) {
                        player.pause();
                    }
                }
            });
        }
    },
};
